import API from './utils/API'

const api = new API()
const prefix = '/test-activity'

const create = (
  { answers, testItemId, testActivityId, ...rest },
  autoSave = false,
  pausing = false
) =>
  api
    .callApi({
      url: `${prefix}/${testActivityId}/test-item/${testItemId}`,
      method: 'post',
      data: { userResponse: answers, ...rest },
      params: { autoSave, pausing },
    })
    /**
     * ASM-749 - resolve the FULL body, not just `result`. The item-save response also carries
     * `pauseState` (edu-api TestActivity.getPauseStateForSave), which the assessment saga uses to
     * veto a question change while the class is paused inside its grace window.
     */
    .then((result) => result.data)

const updateUserWorkTestLevel = ({ testActivityId, groupId, userWork }) =>
  api
    .callApi({
      url: `${prefix}/${testActivityId}/user-work`,
      method: 'put',
      data: { userWork, groupId },
    })
    .then((result) => result.data.result)

export default {
  create,
  updateUserWorkTestLevel,
}
